import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const LOGO_URL = process.env.REACT_APP_LOGO_URL || "https://customer-assets.emergentagent.com/job_closings-concierge/artifacts/16ywe7kj_ChatGPT%20Image%20Feb%2026%2C%202026%2C%2007_04_50%20PM.png";

const footerLinks = {
  services: [
    { name: 'Post-Close Outreach', path: '/services' },
    { name: 'Review Generation', path: '/services' },
    { name: 'Gift Coordination', path: '/services' },
    { name: 'Referral Capture', path: '/services' },
  ],
  company: [
    { name: 'About Us', path: '/about' },
    { name: 'How It Works', path: '/how-it-works' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'Contact', path: '/contact' },
  ],
  resources: [
    { name: 'FAQ', path: '/faq' },
    { name: 'Partners', path: '/partners' },
    { name: 'Book a Demo', path: '/contact' },
  ],
};

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#0A0A0A] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8 mb-16">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" data-testid="footer-logo-link">
              <img
                src={LOGO_URL}
                alt="Better Closings"
                className="h-48 w-auto mb-6"
              />
            </Link>
            <p className="text-neutral-400 text-sm leading-relaxed max-w-sm mb-6">
              The premier post-closing concierge service for elite mortgage professionals. 
              We handle the follow-up so you can focus on closing more loans.
            </p>
            <div className="space-y-3">
              <a
                href="mailto:info@betterclosings.com"
                data-testid="footer-email-link"
                className="flex items-center text-neutral-400 hover:text-[#C9A227] transition-colors text-sm"
              >
                <Mail size={16} className="mr-3" />
                info@betterclosings.com
              </a>
              <a
                href="tel:+18001234567"
                data-testid="footer-phone-link"
                className="flex items-center text-neutral-400 hover:text-[#C9A227] transition-colors text-sm"
              >
                <Phone size={16} className="mr-3" />
                1-800-123-4567
              </a>
              <div className="flex items-center text-neutral-400 text-sm">
                <MapPin size={16} className="mr-3" />
                Nationwide Service
              </div>
            </div>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="text-[#C9A227] font-serif text-lg mb-6">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-neutral-400 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-[#C9A227] font-serif text-lg mb-6">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-neutral-400 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h4 className="text-[#C9A227] font-serif text-lg mb-6">Resources</h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-neutral-400 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-white/10 mb-8" />

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-neutral-500 text-xs">
            © {new Date().getFullYear()} Better Closings. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="text-neutral-500 hover:text-neutral-300 text-xs transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-terms-link"
              className="text-neutral-500 hover:text-neutral-300 text-xs transition-colors"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
